import { Expose } from 'class-transformer'

export class SearchLogType {
  @Expose() id: number

  @Expose({ name: 'search_text' }) searchText: string

  @Expose() updated_at?: string
}
